// Event-bus channel name for value-moment-triggered push priming (gap G6).
//
// Kept in a leaf-level constants file so emitter components (DepositSheet,
// VariantItemsEditor) don't pull the full usePushNotifications.js dependency
// graph (platform adapter → usePwa → vite-plugin-pwa virtual module) into
// their compiled chunks or test runs.
//
// Payload shape: `{ moment: 'orderbox' | 'deposit' | 'deadline' }`.
// App.vue is the single subscriber.
export const PUSH_PRIMING_TRIGGER_EVENT = 'push:trigger-priming';

// ── Welcome push — locked AR copy ────────────────────────────────────────────
// Fired locally (via SW registration.showNotification) immediately after a new
// push subscription is created. Triggers on EVERY new subscription event:
//   - first-ever subscribe
//   - unsubscribe → resubscribe on the same device
//   - existing user subscribes a new device
// Copy is locked (poolit-voice). Only translators / the poolit-voice agent
// should edit these strings.
export const WELCOME_PUSH_TITLE = '🔔 النادي وصّلك — وده بس البداية';
export const WELCOME_PUSH_BODY =
  'اوردراتك وفلوسك ومواعيدك — كلها هتوصلك في اللحظة الصح. أهلاً بك في نادي السيلرز 💖';
export const WELCOME_PUSH_URL = '/home/';
// Standard PWA icon — matches manifest.webmanifest 192×192 entry.
export const WELCOME_PUSH_ICON = '/pwa-192x192.png';

// localStorage key for per-subscription dedup (see triggerWelcomePush).
export const WELCOME_PUSH_LAST_SENT_KEY = 'poolit:push-last-welcome-at';
